import create from 'zustand';
import { UpdateDitaQueryState } from './interfaces/UpdateQueryState';
import { createCommonDitaQuerySlice } from './slices/DitaQuerySlices/CommonDitaQuerySlice';
import { createUpdateDitaQuerySlice } from './slices/DitaQuerySlices/UpdateDitaQuerySlice';

export const useUpdateDitaQueryStore = create<UpdateDitaQueryState>((set) => ({
  ...createCommonDitaQuerySlice(set),
  ...createUpdateDitaQuerySlice(set)
}));
